import { Controller } from 'react-hook-form'
import { MailOpen } from 'lucide-react'
import { CKEditor4 } from '@/components/editor/CKEditor4'
import companyFormStyles from '../../styles/organizationCard.module.css'
import type { OrganizationEditSectionProps } from '../../types/components'
import { ORG_FORM_SUBHEADING, STOCK_LETTER_VARIABLES } from '../../constants/editPage'

export function OrganizationStockLetterTab({ ctx }: OrganizationEditSectionProps) {
  return (
        <div
          id="org-panel-stockletter"
          role="tabpanel"
          aria-labelledby="org-tab-stockletter"
          hidden={ctx.selectedTab !== 'stockletter'}
        >
          {ctx.selectedTab === 'stockletter' && (
            <div className="space-y-6">
              <div className={companyFormStyles.card}>
                <div className={companyFormStyles.cardHeader}>
                  <MailOpen className={companyFormStyles.cardIcon} />
                  <h2 className={companyFormStyles.cardTitle}>
                    Stock Letter
                  </h2>
                </div>

                <div className={companyFormStyles.cardBody}>
                  <div className="space-y-6">
                    <div>
                      <p className={ORG_FORM_SUBHEADING} id="org-stock-letter-variables-heading">
                        Available Variables:
                      </p>
                      <div
                        className={companyFormStyles.variablesBox}
                        aria-labelledby="org-stock-letter-variables-heading"
                        role="list"
                        aria-label="Stock letter template variables"
                      >
                        <div className="flex flex-wrap gap-x-2 gap-y-2">
                          {STOCK_LETTER_VARIABLES.map((v) => (
                            <code
                              key={v}
                              className={companyFormStyles.variableCode}
                            >
                              {v}
                            </code>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className={companyFormStyles.formGroup}>
                      <label className={companyFormStyles.formLabel} htmlFor="org-stock-letter">
                        Stock Letter Template
                      </label>
                      <Controller
                        name="stock_letter"
                        control={ctx.control}
                        render={({ field: { value, onChange } }) => (
                          <CKEditor4 id="org-stock-letter" value={value || ''} onChange={onChange} />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

  )
}
